import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { first, map } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { APP_ROUTE_PATH } from 'src/app/core/enums';
import { CleanerService } from 'src/app/core/services/cleaner/cleaner.service';

/**
 * Guard function to check if the user is logged in before navigating to a route.
 * Injects the authentication service and router to check the user's login status.
 * If the user is logged in, allows navigation by returning true.
 * If the user is not logged in, navigates to the login page and returns false.
 * @returns {Observable<boolean>} An observable indicating if navigation is allowed.
 */
export const isLoggedInGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const cleanerService = inject(CleanerService);

  return authService.isLoggedIn.pipe(
    first(),
    map((isLoggedIn: boolean) => {
      if (isLoggedIn) {
        return true;
      }

      cleanerService.clearAllData();

      return router.createUrlTree([APP_ROUTE_PATH.login]);
    })
  );
};
